export default function(el) {
    const modul = document.querySelector('.modal');
    console.log(modul);
    const link = document.querySelector('.modal__close')

    if (localStorage.getItem('cookieState') != 'accepted') {
        link.addEventListener('click', () => {
            modul.style.display = 'none';
            localStorage.setItem('cookieState', 'accepted');
        });
    }
}